import React, {useEffect, useState} from 'react'
import s from './AccountOverview.module.css'

import plus from "../../../../assets/newImg/personalAccount/plusWhite.svg"
import {Checkbox, ConfigProvider, Dropdown, Layout, MenuProps, Popover, Space} from 'antd';
import arrow from '../../../../assets/newImg/personalAccount/arrow.svg'
import Table, {ColumnsType} from "antd/es/table";
import info from "../../../../assets/newImg/personalAccount/information.svg";

import {ReactComponent as Back} from '../../../../assets/newImg/personalAccount/back.svg'
import {CheckboxChangeEvent} from "antd/lib/checkbox";
import Icon from "@ant-design/icons";
import {useAppDispatch, useAppSelector} from "../../../../hooks/redux";
import {CreateAccountsThunk, GetAccountsListThunk} from '../../../../store/reducers/ActionCreators';
import {Loader} from '../../../../components/Loader/Loader';
import CustomModal from '../../../../components/ui/CustomModal/CustomModal';
import MyBtn from '../../../../components/ui/MyBtn/MyBtn';
import TransparentButton from '../../../../components/ui/TransparentButton/TransparentButton';
import AccountCardMobile from "../../../../components/ui/AccountCardMobile/AccountCardMobile";

import usdIcon from '../../../../assets/icons/сurrencyIcons/USD.svg'
import eurIcon from '../../../../assets/icons/сurrencyIcons/EUR.svg'
import gbpIcon from '../../../../assets/icons/сurrencyIcons/GBP.svg'
import cadIcon from '../../../../assets/icons/сurrencyIcons/cad.svg'
import cnhIcon from '../../../../assets/icons/сurrencyIcons/CNY.svg'
import cnyIcon from '../../../../assets/icons/сurrencyIcons/CNY.svg'
import ngnIcon from '../../../../assets/icons/сurrencyIcons/NGN.svg'
import aedIcon from '../../../../assets/icons/сurrencyIcons/AED.svg'
import sgdIcon from '../../../../assets/icons/сurrencyIcons/SGD.svg'
import hkdIcon from '../../../../assets/icons/сurrencyIcons/HKD.svg'
import jpyIcon from '../../../../assets/icons/сurrencyIcons/JPY.svg'
import btcIcon from '../../../../assets/icons/сurrencyIcons/BTC.svg'
import ethIcon from '../../../../assets/icons/сurrencyIcons/ethr.svg'
import solIcon from '../../../../assets/icons/сurrencyIcons/Solana.svg'
import xrpIcon from '../../../../assets/icons/сurrencyIcons/Xrpl.svg'
import tonIcon from '../../../../assets/icons/сurrencyIcons/TON.svg'
import usdtIcon from '../../../../assets/icons/сurrencyIcons/USDT.svg'
import usdcIcon from '../../../../assets/icons/сurrencyIcons/USDC.svg'
import xauIcon from '../../../../assets/icons/сurrencyIcons/XAU.svg'
import xagIcon from '../../../../assets/icons/сurrencyIcons/XAG.svg'
import xpdIcon from '../../../../assets/icons/сurrencyIcons/XPD.svg'
import xptIcon from '../../../../assets/icons/сurrencyIcons/XPT.svg'
import {popoverStyles} from "../../../../components/BankTransferFormBusiness/BankTransferFormBusiness";

const menuStyle = {
    border: '1.5px solid #EEEFEF',
    borderRadius: 8,
    overflow: 'auto',
    height: 440,
    width: '100%',
};

const contentStyle = {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '18px',
    color: '#979797'
};

const currencyStyle = {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '18px',
    color: '#979797',
    width: 'fit-content'
};

interface DataType {
    pendingIncomingTransactionsSum: number;
    pendingOutgoingTransactionsSum: number;
    availableBalance: number;
    balance: number,
    currency: string,
    number: string,
    status: string
}

const columns: ColumnsType<DataType> = [
    {
        title: 'Number',
        dataIndex: 'number',
    },
    {
        title: 'Currency',
        dataIndex: 'currency',
        align: 'right'
    },
    {
        title: 'Pending incoming transactions',
        dataIndex: 'pendingIncomingTransactionsSum',
        align: 'right'
    },
    {
        title: 'Pending Outgoing transactions',
        dataIndex: 'pendingOutgoingTransactionsSum',
        align: 'right'
    },
    {
        title: 'Current Balace',
        dataIndex: 'totalBalance',
        align: 'right'
    },
    {
        title: 'Available balance',
        dataIndex: 'availableBalance',
        align: 'right'
    },
];

export const AccountOverview = () => {
    const dispatch = useAppDispatch()
    const {userToken} = useAppSelector(store => store.userReducer.user)
    const accounts = useAppSelector(store => store.userReducer.accountsList.accounts)
    const {isLoading} = useAppSelector(store => store.userReducer)
    const [currency, setCurrency] = useState('USD')
    const [showModal, setShowModal] = useState(false)
    const [newAccounts, setNewAccounts] = useState({
        CAD: false,
        EUR: false,
        GBP: false,
        USD: false,
        USDT_TRC20: false,
        USDT_ERC20: false,
        USDC_ERC20: false,
        TON: false,
        XAU: false,
        XAG: false,
        XPD: false,
        XPT: false,
        SGD: false,
        DDT: false,
        HKD: false,
        JPY: false,
        CNH: false,
        AED: false,
        NGN: false,
        CNY: false,
        BTC: false,
        ETH: false,
        SOL: false,
        XRP: false,
    })
    const [showSuccess, setShowSuccess] = useState(false)
    const [showError, setShowError] = useState(false)
    const accountsStatistics = useAppSelector(store => store.userReducer.accountsList.statistics)

    useEffect(() => {
        dispatch(GetAccountsListThunk(userToken, currency))
    }, [])

    const optionsTwo: MenuProps['items'] = [
        {
            label: 'Commission statement for the previous year',
            key: '0',
        },
        {
            label: 'Commission statement from the beginning of the current calendar year',
            key: '1',
        },
    ];

    const options: MenuProps['items'] = [
        {
            label: 'CAD',
            key: 'CAD',
        },
        {
            label: 'BTC',
            key: 'BTC',
        },
        {
            label: 'ETH',
            key: 'ETH',
        },
        {
            label: 'SOL',
            key: 'SOL',
        },
        {
            label: 'XRP',
            key: 'XRP',
        },
        {
            label: 'EUR',
            key: 'EUR',
        },
        {
            label: 'GBP',
            key: 'GBP',
        },
        {
            label: 'USD',
            key: 'USD',
        },
        {
            label: 'USDT_TRC20',
            key: 'USDT_TRC20',
        },
        {
            label: 'USDT_ERC20',
            key: 'USDT_ERC20',
        },
        {
            label: 'USDC_ERC20',
            key: 'USDC_ERC20',
        },
        {
            label: 'TON',
            key: 'TON',
        },
        {
            label: 'XAU',
            key: 'XAU',
        },
        {
            label: 'XAG',
            key: 'XAG',
        },
        {
            label: 'XPD',
            key: 'XPD',
        },
        {
            label: 'XPT',
            key: 'XPT',
        },
        {
            label: 'SGD',
            key: 'SGD',
        },
        {
            label: 'HKD',
            key: 'HKD',
        },
        {
            label: 'JPY',
            key: 'JPY',
        },
        {
            label: 'CNH',
            key: 'CNH',
        },
        {
            label: 'AED',
            key: 'AED',
        },
        {
            label: 'NGN',
            key: 'NGN',
        },
        {
            label: 'CNY',
            key: 'CNY',
        },
    ];

    const menuItems = options.map((option: any) => ({
        key: option.value,
        label: (
            <div onClick={() => currencyHandleChange(option.key)}>
                {option.label}
            </div>
        ),
    }));

    const getType = (type: string) => {
        if (type === 'Requested') {
            return 'pending approval'
        }
        if (type === 'Inactive') {
            return 'blocked'
        }
    }

    const tableData = accounts?.map((item: DataType) => {

        return {
            key: item.number,
            number: <div className={item.status === 'Active' ? s.numberWrapper : `${s.numberWrapper} ${s.disabled}`}>
                {item.number}
                <Popover content={"Your internal account number."}
                         color={'#EEEFEF'}
                         placement={"bottom"}
                         styles={{
                            container: {

                         }}
                         }
                         overlayInnerStyle={{
                             fontFamily: 'Inter',
                             padding: '13px 16px',
                             boxShadow: 'none',
                             backgroundColor: '#EDEDED',
                            color: '#000',
                            fontWeight: '700',
                         }}
                >
                    <img src={info} alt=""/>
                </Popover>
            </div>,
            currency: <p className={item.status !== 'Active' ? s.disabled : ''}>{item.currency}</p>,
            pendingIncomingTransactionsSum: item.status !== 'Requested' ?
                <p className={item.status !== 'Active' ? s.disabled : ''}>{item.pendingIncomingTransactionsSum + ' ' + item.currency}</p> : '',
            pendingOutgoingTransactionsSum: item.status !== 'Requested' ?
                <p className={item.status !== 'Active' ? s.disabled : ''}>{item.pendingOutgoingTransactionsSum + ' ' + item.currency}</p> : '',
            totalBalance: item.status !== 'Requested' ?
                <p className={item.status !== 'Active' ? s.disabled : ''}>{item.balance + ' ' + item.currency}</p> : '',
            availableBalance: item.status === 'Active' ? item.availableBalance + ' ' + item.currency :
                <p className={item.status === 'Requested' ? s.pending : s.blocked}>{getType(item.status)}</p>,
        }
    })

    const onChange = (e: CheckboxChangeEvent) => {
        e.stopPropagation()

        let name = e.target.name;
        if (name === 'CAD') {
            setNewAccounts({...newAccounts, CAD: !newAccounts.CAD})
        }
        if (name === 'EUR') {
            setNewAccounts({...newAccounts, EUR: !newAccounts.EUR})
        }
        if (name === 'GBP') {
            setNewAccounts({...newAccounts, GBP: !newAccounts.GBP})
        }
        if (name === 'USD') {
            setNewAccounts({...newAccounts, USD: !newAccounts.USD})
        }
        if (name === 'USDT_TRC20') {
            setNewAccounts({...newAccounts, USDT_TRC20: !newAccounts.USDT_TRC20})
        }
        if (name === 'USDT_ERC20') {
            setNewAccounts({...newAccounts, USDT_ERC20: !newAccounts.USDT_ERC20})
        }
        if (name === 'USDC_ERC20') {
            setNewAccounts({...newAccounts, USDC_ERC20: !newAccounts.USDC_ERC20})
        }
        if (name === 'TON') {
            setNewAccounts({...newAccounts, TON: !newAccounts.TON})
        }
        if (name === 'XAU') {
            setNewAccounts({...newAccounts, XAU: !newAccounts.XAU})
        }
        if (name === 'XAG') {
            setNewAccounts({...newAccounts, XAG: !newAccounts.XAG})
        }
        if (name === 'XPD') {
            setNewAccounts({...newAccounts, XPD: !newAccounts.XPD})
        }
        if (name === 'XPT') {
            setNewAccounts({...newAccounts, XPT: !newAccounts.XPT})
        }
        if (name === 'SGD') {
            setNewAccounts({...newAccounts, SGD: !newAccounts.SGD})
        }
        if (name === 'HKD') {
            setNewAccounts({...newAccounts, HKD: !newAccounts.HKD})
        }
        if (name === 'JPY') {
            setNewAccounts({...newAccounts, JPY: !newAccounts.JPY})
        }
        if (name === 'CNH') {
            setNewAccounts({...newAccounts, CNH: !newAccounts.CNH})
        }
        if (name === 'AED') {
            setNewAccounts({...newAccounts, AED: !newAccounts.AED})
        }
        if (name === 'NGN') {
            setNewAccounts({...newAccounts, NGN: !newAccounts.NGN})
        }
        if (name === 'CNY') {
            setNewAccounts({...newAccounts, CNY: !newAccounts.CNY})
        }
        if (name === 'BTC') {
            setNewAccounts({...newAccounts, BTC: !newAccounts.BTC})
        }
        if (name === 'ETH') {
            setNewAccounts({...newAccounts, ETH: !newAccounts.ETH})
        }
        if (name === 'SOL') {
            setNewAccounts({...newAccounts, SOL: !newAccounts.SOL})
        }
        if (name === 'XRP') {
            setNewAccounts({...newAccounts, XRP: !newAccounts.XRP})
        }

    };

    const formatCurrencyKey = (key: string): string => {
        // Заменяем underscore на пробел для конкретных случаев
        // if (key === 'USDT_ERC20') {
        //     return 'USDT ERC20'
        // }
        // Другие правила
        return key.replace(/_/g, ' ') // если нужно все underscore заменить на пробелы
    }

    const createAccounts = () => {
        const currencies = []
        for (let newAccountsKey in newAccounts) {
            // @ts-ignore
            if (newAccounts[newAccountsKey] === true) {
                const formattedKey = formatCurrencyKey(newAccountsKey)
                currencies.push(formattedKey)
            }
        }
        !!currencies.length &&
        dispatch(CreateAccountsThunk(userToken, {currencies}))
            .then((res) => {
                if (res.status === 200) {
                    setShowSuccess(true)
                }
            }).catch((e) => {
            setShowError(true)
        })
    }

    const getSuccessTemplate = () => {
        return (
            <>
                <h3 className={s.modalTitle}>Success!</h3>
                <h4 className={s.modalSubtitleSuccess}>Your request has been sent.</h4>
                <div className={s.buttonsWrapperSuccess}>
                    <MyBtn style={{width: 180}} title={'Ok'} onClick={() => {
                        setShowSuccess(false);
                        setShowModal(false);
                        setNewAccounts({
                            CAD: false,
                            EUR: false,
                            GBP: false,
                            USD: false,
                            USDT_TRC20: false,
                            USDT_ERC20: false,
                            USDC_ERC20: false,
                            TON: false,
                            XAU: false,
                            XAG: false,
                            XPD: false,
                            XPT: false,
                            SGD: false,
                            DDT: false,
                            HKD: false,
                            JPY: false,
                            CNH: false,
                            AED: false,
                            NGN: false,
                            CNY: false,
                            BTC: false,
                            ETH: false,
                            SOL: false,
                            XRP: false,
                        })
                        dispatch(GetAccountsListThunk(userToken, currency))
                    }}/>
                </div>
            </>
        )
    }

    const getErrorTemplate = () => {
        return (
            <>
                <h3 className={s.modalTitle}>Oops!</h3>
                <h4 className={s.modalSubtitleSuccess}>Something went wrong. Please try again</h4>
                <div className={s.buttonsWrapperSuccess}>
                    <MyBtn buttonType={'error'} style={{width: 180}} title={'Ok'} onClick={() => {
                        setShowSuccess(false);
                        setShowError(false);
                        setNewAccounts({
                            CAD: false,
                            EUR: false,
                            GBP: false,
                            USD: false,
                            USDT_TRC20: false,
                            USDT_ERC20: false,
                            USDC_ERC20: false,
                            TON: false,
                            XAU: false,
                            XAG: false,
                            XPD: false,
                            XPT: false,
                            SGD: false,
                            DDT: false,
                            HKD: false,
                            JPY: false,
                            CNH: false,
                            AED: false,
                            NGN: false,
                            CNY: false,
                            BTC: false,
                            ETH: false,
                            SOL: false,
                            XRP: false,
                        })
                    }}/>
                </div>
            </>
        )
    }

    const getTemplateForCreateNewAccount = () => {
        return (
            <>
                <h3 className={s.modalTitle}>Add a new account</h3>
                <h4 className={s.modalSubtitle}>Choose a currency for the new account (one or more).</h4>
                <h4 className={s.currency_title}>Fiat accounts:</h4>
                <div className={s.checkboxes}>
                    <ConfigProvider theme={{
                        token: {
                            fontSize: 14,
                            fontFamily: 'Inter',
                            colorText: '#979797',
                            colorPrimary: 'var(--primary-color)',
                            colorBorder: '#EEEFEF',
                            colorPrimaryBorderHover: '#979797'
                        }
                    }}>
                        <div className={s.fiat_container_wrapper}>
                            <Checkbox name={'USD'} checked={newAccounts.USD} onChange={onChange}
                                      className={s.checkbox_custom_style}><img
                                src={usdIcon} alt=""/> USD</Checkbox>
                            <Checkbox name={'EUR'} checked={newAccounts.EUR} onChange={onChange}
                                      className={s.checkbox_custom_style}><img
                                src={eurIcon} alt=""/> EUR</Checkbox>
                            <Checkbox name={'GBP'} checked={newAccounts.GBP} onChange={onChange}
                                      className={s.checkbox_custom_style}><img
                                src={gbpIcon} alt=""/> GBP</Checkbox>
                            <Checkbox name={'CAD'} checked={newAccounts.CAD} onChange={onChange}
                                      className={s.checkbox_custom_style}> <img src={cadIcon}
                                                                                alt="#cad_flag"/> CAD</Checkbox>
                            <Checkbox name={'CNH'} checked={newAccounts.CNH} onChange={onChange}
                                      className={s.checkbox_custom_style}><img
                                src={cnhIcon} alt=""/> CNH</Checkbox>
                            <Checkbox name={'CNY'} checked={newAccounts.CNY} onChange={onChange}
                                      className={s.checkbox_custom_style}><img
                                src={cnyIcon} alt=""/> CNY</Checkbox>
                            <Checkbox name={'NGN'} checked={newAccounts.NGN} onChange={onChange}
                                      className={s.checkbox_custom_style}><img
                                src={ngnIcon} alt=""/> NGN</Checkbox>
                            <Checkbox name={'AED'} checked={newAccounts.AED} onChange={onChange}
                                      className={s.checkbox_custom_style}><img
                                src={aedIcon} alt=""/> AED</Checkbox>
                            <Checkbox name={'SGD'} checked={newAccounts.SGD} onChange={onChange}
                                      className={s.checkbox_custom_style}><img
                                src={sgdIcon} alt=""/> SGD</Checkbox>
                            <Checkbox name={'HKD'} checked={newAccounts.HKD} onChange={onChange}
                                      className={s.checkbox_custom_style}><img
                                src={hkdIcon} alt=""/> HKD</Checkbox>
                            <Checkbox name={'JPY'} checked={newAccounts.JPY} onChange={onChange}
                                      className={s.checkbox_custom_style}><img
                                src={jpyIcon} alt=""/> JPY</Checkbox>

                        </div>
                        <div className={s.fiat_container_wrapper}>
                            <h4 className={s.currency_title}>Cryptocurrency accounts:</h4>
                            <div className={s.crypto_list_wrapper}>
                                <Checkbox name={'USDT_TRC20'} checked={newAccounts.USDT_TRC20} onChange={onChange} className={s.checkbox_custom_style}>
                                    <img src={usdtIcon} alt=""/>
                                    <p className={s.title_currency}>
                                        USDT <span>TRC20</span>
                                    </p>
                                </Checkbox>
                                <Checkbox name={'USDT_ERC20'} checked={newAccounts.USDT_ERC20} onChange={onChange} className={s.checkbox_custom_style}>
                                    <img src={usdtIcon} alt=""/>
                                    <p className={s.title_currency}>
                                        USDT <span>ERC20</span>
                                    </p>
                                </Checkbox>
                                <Checkbox name={'USDC_ERC20'} checked={newAccounts.USDC_ERC20} onChange={onChange} className={s.checkbox_custom_style}>
                                    <img src={usdcIcon} alt=""/>
                                    <p className={s.title_currency}>
                                        USDC <span>ERC20</span>
                                    </p>
                                </Checkbox>
                                <Checkbox name={'BTC'} checked={newAccounts.BTC} onChange={onChange} className={s.checkbox_custom_style}>
                                    <img src={btcIcon} alt=""/> BTC</Checkbox>
                                <Checkbox name={'ETH'} checked={newAccounts.ETH} onChange={onChange} className={s.checkbox_custom_style}>
                                    <img src={ethIcon} alt=""/> ETH</Checkbox>
                                <Checkbox name={'SOL'} checked={newAccounts.SOL} onChange={onChange} className={s.checkbox_custom_style}>
                                    <img src={solIcon} alt=""/> SOL</Checkbox>
                                <Checkbox name={'XRP'} checked={newAccounts.XRP} onChange={onChange} className={s.checkbox_custom_style}>
                                    <img src={xrpIcon} alt=""/> XRP</Checkbox>
                                <Checkbox name={'TON'} checked={newAccounts.TON} onChange={onChange}
                                          className={s.checkbox_custom_style}>
                                    <img src={tonIcon} alt=""/> TON
                                </Checkbox>
                            </div>
                        </div>
                        <div className={s.asset_container_wrapper}>
                            <h4 className={s.currency_title}>Asset accounts:</h4>
                            <div className={s.asset_container_wrapper}>
                                <Checkbox name={'XAU'} checked={newAccounts.XAU} onChange={onChange}
                                          className={s.checkbox_custom_style}>
                                    <img src={xauIcon} alt=""/> XAU
                                </Checkbox>
                                <Checkbox name={'XAG'} checked={newAccounts.XAG} onChange={onChange}
                                          className={s.checkbox_custom_style}>
                                    <img src={xagIcon} alt=""/> XAG
                                </Checkbox>
                                <Checkbox name={'XPD'} checked={newAccounts.XPD} onChange={onChange}
                                          className={s.checkbox_custom_style}>
                                    <img src={xpdIcon} alt=""/> XPD
                                </Checkbox>
                                <Checkbox name={'XPT'} checked={newAccounts.XPT} onChange={onChange}
                                          className={s.checkbox_custom_style}>
                                    <img src={xptIcon} alt=""/> XPT
                                </Checkbox>
                            </div>
                        </div>

                    </ConfigProvider>
                </div>
                <div className={s.buttonsWrapper}>
                    <TransparentButton personalAccount onClick={() => {
                        setShowModal(false)
                    }} style={{minWidth: 180}} title={'Cancel'} medium
                                       icon={<Icon component={() => <Back/>} rev={undefined}/>}/>
                    <MyBtn personalAccount style={{width: 180}} title={'Send Request'} medium onClick={() => createAccounts()}/>
                </div>
            </>
        )
    }

    const currencyHandleChange = (e: any) => {
        setCurrency(e)
        dispatch(GetAccountsListThunk(userToken, e))
    }

    const isMobile = window.innerWidth <= 768

    return (
        isLoading ? <Loader/> :
            <div className={s.accountOverviewWrapper}>

                <CustomModal isAccountCreation type={showError ? 'error' : undefined} setIsModalOpen={setShowModal}
                             isModalOpen={showModal} children={
                    <div className={s.modalContent}>
                        {
                            (showError && getErrorTemplate()) || (showSuccess ? getSuccessTemplate() : getTemplateForCreateNewAccount())
                        }
                    </div>
                }/>
                <div className={s.topMenu}>
                    <h2 className={s.topMenuTitle}>Currency Accounts</h2>
                    <div className={s.topMenuButtons}>
                        <MyBtn icon={plus}
                               style={{paddingLeft: '26px', paddingRight: '22px', width: 'fit-content', height: 44}}
                               onClick={() => setShowModal(true)}
                               title={'New Account'}
                               personalAccount={true}/>

                    </div>
                </div>
                {!isMobile
                    ? <Layout>
                        <Table
                            bordered={false}
                            className={s.accountTable}
                            columns={columns}
                            dataSource={tableData}
                            pagination={false}
                            summary={(pageData) => {
                                let total = 0;
                                pageData.forEach(() => {
                                    total += total;
                                });

                                return (
                                    <>
                                        <Table.Summary.Row>
                                            <Table.Summary.Cell index={0} colSpan={3} className={s.footerTotalCell}>
                                                <div className={s.numberWrapper}>
                                                    <p>Total</p>
                                                    <Popover content={'“In total on personal account” is given in the selected currency after conversion at the accounting rate.'}
                                                             color={'#EDEDED'}
                                                             placement={"bottom"}

                                                             overlayInnerStyle={{
                                                                 fontFamily: 'Inter',
                                                                 padding: '13px 16px',
                                                                 backgroundColor: '#EDEDED',
                                                                 color: '#000',
                                                                 fontWeight: '700',
                                                                 width: '280px',
                                                                 boxShadow: 'none'
                                                             }}
                                                    >
                                                        <img src={info} alt=""/>
                                                    </Popover>
                                                </div>
                                                <Dropdown menu={{items: menuItems}} placement={"bottomCenter"}
                                                          trigger={['click']}
                                                          dropdownRender={(menu: React.ReactNode) => (
                                                              <div style={currencyStyle}>
                                                                  {React.cloneElement(menu as React.ReactElement, {style: menuStyle})}
                                                              </div>
                                                          )}>
                                                    <Space style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: 86,
                                                        height: 44,
                                                        border: '1.5px solid #EEEFEF',
                                                        borderColor: '#EEEFEF',
                                                        borderRadius: 12,
                                                        fontFamily: 'Inter',
                                                        fontWeight: 500,
                                                        fontSize: 14,
                                                        lineHeight: '18px',
                                                        color: '#979797'
                                                    }}>
                                                        <p>{currency}</p>
                                                        <img src={arrow} alt=""/>
                                                    </Space>
                                                </Dropdown>

                                            </Table.Summary.Cell>

                                            <Table.Summary.Cell index={2} align={'right'} colSpan={2}
                                                                className={s.footerCell}>
                                                {accountsStatistics?.totalPendingIncomingTransactionsSum} {currency}
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={2} align={'right'} className={s.footerCell}>
                                                {accountsStatistics?.totalPendingOutgoingTransactionsSum} {currency}
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={2} align={'right'} className={s.footerCell}>
                                                {accountsStatistics?.totalBalance} {currency}
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={2} align={'right'} className={s.footerCell}>
                                                {accountsStatistics?.totalAvailableBalance} {currency}
                                            </Table.Summary.Cell>
                                        </Table.Summary.Row>
                                    </>
                                );
                            }}
                        />
                    </Layout>
                    : <>
                        {
                            accounts?.map((item: any) =>
                                <AccountCardMobile
                                    status={item.status}
                                    number={item.number}
                                    currency={item.currency}
                                    balance={item.balance}
                                />
                            )
                        }
                    </>
                }
            </div>

    )
}
